import { styled, Box, Typography } from "@mui/material";

export const S = {
    Title: styled(Typography)(({ theme }) => ({
        fontWeight: 600,
    })),

    Calculator: styled(Box)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#DBD9FF52",
        borderRadius: theme.spacing(2),
        padding: theme.spacing(4),
        gap: theme.spacing(2),
    })),

    Inner: styled(Box)(({ theme }) => ({
        marginTop: theme.spacing(10),
    })),

    SliderField: styled(Box)(({ theme }) => ({
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(5),
    })),

    Row: styled(Box)(({ theme }) => ({
        display: "flex",
        gap: theme.spacing(15),
        padding: theme.spacing(3, 6),
        borderBottom: `1px solid ${theme.palette.grey[100]}`,
    })),
};
